<template>
    <div id="alert">
        <div class="" v-bind:class="getClass" v-if="showAlert" role="alert">
            <i class="" v-bind:class="getIcon"></i><span class="font-size-11 font-size-sm-10" v-html="content"></span>
            <button v-if="closebtn" type="button" class="close" aria-label="Close" @click="close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</template>
<script>
export default {
    name: "Alert",
    props : {
        empty:{
            type: Boolean,
            default: false
            },
        success : {
            type: Boolean,
            default: false
            },
        info : {
            type: Boolean,
            default: false
            },
        danger : {
            type: Boolean,
            default: false
            },
        warning:{
            type: Boolean,
            default: false
            },
        content : {
            type: String,
            default: '',
            },
        closebtn:{
            type: Boolean,
            default: false
            },
    },
    computed:{
        getClass(){
            if (this.success){
                return 'alert alert-success'
            } else if (this.info){
                return 'alert alert-info'
            } else if (this.danger){
                return 'alert alert-danger'
            } else if (this.warning) {
              return "alert alert-warning"
            } else if  (this.empty){
                return 'p-0 invalid-feedback d-block'
            } else {
                return ''
            }
        },
        getIcon(){
            if (this.info){
                return 'fa mr-3 fa-exclamation-circle color-star-full'
            } else if (this.danger){
                return 'fa mr-3 fa-exclamation-circle color-red'
            } else {
                return ''
            }
        }
        
    },
    data(){
        return{
            showAlert:true,
        }
    },
    methods:{
        close(){
            this.showAlert = false
        }
    }
}
</script>
<style>
.background-red{
    background-color: #e29f9f;
}

</style>